import { Point } from 'components/common/types/Geometry';

export const calculateGridPosition = (index: number, maxElementsInRow: number): Point => {
  return {
    x: Math.floor(index % maxElementsInRow),
    y: Math.floor(index / maxElementsInRow),
  };
};
